import React from 'react';
import Layout from '../components/layout/Layout';
import CategoryScoreList from '../components/categoryscore/CategoryScoreList';
import CategoryScoreModal from '../components/categoryscore/CategoryScoreModal';
import { TestMasterProvider } from '../contexts/TestMasterContext';

const CategoryScoreMasterPage = () => {
  return (
    <Layout>
      <TestMasterProvider>
        <CategoryScoreList />
        <CategoryScoreModal />
      </TestMasterProvider>
    </Layout>
  );
};

export default CategoryScoreMasterPage;
